<template>
  <v-container
    ref="container"
    v-resize="resize"
    class="widgetText--text widget pa-0"
    style="position: relative; height: 100%; overflow: hidden">
    <BaseWidgetHeader
      ref="widgetHeader" label="Извештај за округ" :loading="loading"
      @close-parent-widget="close" />
    <v-row class="pt-4 px-5">
      <v-col cols="12" align-self="center" class="pt-0 pb-4">
        <BaseAutocomplete
          v-model="okrug" label="Изаберите округ за који желите да генеришете извештај" :items="okruzi"
          item-text="value" item-value="code" return-object />
      </v-col>
      <v-col cols="12" align-self="center" class="pt-0 pb-4">
        <BaseAutocomplete
          v-model="year1" label="Година од" :items="years"
          item-text="noText" />
      </v-col>
      <v-col cols="12" align-self="center" class="pt-0 pb-4">
        <BaseAutocomplete
          v-model="year2" label="Година до" :items="years"
          item-text="noText" />
      </v-col>
    </v-row>
    <div
      id="footerDiv"
      ref="footerDiv"
      style="position: absolute; bottom: 0px; overflow: hidden; width: 100%"
      class="pt-4 pb-2">
      <v-row>
        <v-col cols="12" class="pb-2">
          <v-divider />
        </v-col>
      </v-row>
      <v-row
        align="center" align-content="center" justify="center"
        class="px-5">
        <v-col class="py-1 px-1" align-self="center" cols="12">
          <BasePrimaryBtn
            class="px-0" :loading="loading"
            title="Генеришете извештај"
            :disable="loading"
            :parent-widget="$options.name"
            @click="getIzvestaj" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import * as urlUtils from '@arcgis/core/core/urlUtils'
import * as queryTask from '@arcgis/core/rest/query'
import Query from '@arcgis/core/rest/support/Query'
import axios from 'axios'
export default {
  name: 'JppsIzvestaj',

  data () {
    return {
      headerHeight: '0px',
      okrug: '',
      okruzi: [],
      urlOkruzi: 'http://192.168.1.18:6080/arcgis/rest/services/JPPS_REPORTS/MapServer',
      proxy: 'https://serbia.gdi.net/proxytemp/proxy.jsp',
      years: [],
      year1: 2018,
      year2: 2022,
    }
  },
  computed: {
    activeTool () {
      return this.$store.getters.getActiveTool
    },
    loading () {
      return this.$store.getters.getExternalJs?.loading ? this.$store.getters.getExternalJs?.loading : false
    },

  },
  watch: {

    activeTool (newValue) {
      if (newValue === 'JppsIzvestaj') {
        this.resize()
      } else {
        this.value = null
        if (this.$options.selectionGraphicsLayer) {
          this.$options.selectionGraphicsLayer.removeAll()
          this.graphicCreated = false
        }
        if (this.$options.clickListener) {
          this.$options.clickListener.remove()
        }
      }
    },

  },
  async created () {
    console.log('e')
    urlUtils.addProxyRule({
      urlPrefix: this.urlOkruzi,
      proxyUrl: this.proxy,
    })
    const queryTaskParameters = new Query({
      outFields: ['*'],
      returnGeometry: false,
      where: '1=1',
    })
    const result = await queryTask.executeQueryJSON(this.urlOkruzi + '/' + 10, queryTaskParameters)
    for (const item of result.features) {
      this.okruzi.push({ value: item.attributes.imeokrug, code: item.attributes.sifokrug })
    }

    const currentYear = new Date().getFullYear()
    const endYear = currentYear - 1
    const years = []

    for (let year = 2015; year <= endYear; year++) {
      years.push(year)
    }
    this.years = years
    // this.getConfig()
  },
  methods: {
    async getConfig () {
      const config = await axios.post('/getCustomConfig', {
        customName: 'JppsIzvestaj',
        viewer: this.$store.getters.getViewerName,
      }, {
        headers: { Authorization: 'Bearer ' + this.$store.getters.getAccessToken },
      })
      console.log(config.data)
    },
    getIzvestaj () {
      if (!this.year1 || !this.year2 || this.year2 - this.year1 < 0 || !this.okrug) {
        this.$store.dispatch('showSnackbar', { color: 'error', customText: 'Vrednosti nisu ispravno unete. Molimo, unesite odgovarajuće vrednosti' })
        return
      }
      if (!this.year1 || !this.year2 || this.year2 - this.year1 > 4) {
        this.$store.dispatch('showSnackbar', { color: 'error', customText: 'Izveštaj za okrug je moguće kreirati za period od najviše 5 godina' })
        return
      }

      // eslint-disable-next-line no-undef
      generateReport({
        attributes: {
          sifokrug: this.okrug.code,
          imeokrug: this.okrug.value,
        },
        startYear: this.year1,
        endYear: this.year2,
        symbol: null,
      }, this)
    },
    close () {
      this.$options.selectionGraphicsLayer?.removeAll()
      this.graphicCreated = false
      this.$options.savedGeometryForQuerying = null
      this.$store.dispatch('unsetCurrentWidgetFromMapInteraction', this.$options.name)
      this.$store.dispatch('unSetActiveTool')
    },
    resize () {
      if (this.activeTool === 'JppsIzvestaj') {
        const containerH = this.$refs.container.clientHeight
        const titleH = this.$refs.widgetHeader.$refs.title.clientHeight
        const dividerH = this.$refs.widgetHeader.$refs.divider.clientHeight
        const tabsH = 30
        const layersH = this.layers ? this.$refs.layers.clientHeight : 0
        const footerH = this.$refs.footerDiv?.clientHeight ? this.$refs.footerDiv?.clientHeight : 0
        this.footerHeight = footerH + 'px'
        const h = containerH - titleH - dividerH - layersH - footerH - tabsH
        this.computedHeight = h + 'px'
      }
    },

  },
}
</script>

<style scoped>
.absolutePosition {
    position: absolute;
    display: block;
    z-index: 100;
}
.column-name {
  font-weight: 500;
  font-size: 14px;
}
</style>
